import { Typography, styled } from '@mui/material';

export const DialogInfoTypography = styled(Typography)({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '26px',
}); 